import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default [
  {
    path: '/delivery-request',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc = hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        if (!acc) return next({ name: 'Liveview' })

        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/delivery-request'),
    children: [
      {
        path: '',
        name: 'Delivery Request List',
        component: () => import('@/router/views/delivery-request/contents/List'),
      },
      {
        path: ':id',
        name: 'Delivery Request Detail',
        component: () => import('@/router/views/delivery-request/contents/Detail'),
      },
      {
        path: '/fleet-task-request/:id',
        name: 'Fleet Task Request Detail',
        meta: {
          authRequired: true,
          hasAccess: true,
          beforeResolve(_, routeFrom, next) {    
            Helper.methods.userLogging('Access', _)
            next()
          },
        },
        component: () => import('@/router/views/delivery-request/contents/DetailFleetTask'),
      },
    ],
  },
]
